import React, { useState } from 'react'
import {
  Box,
  DemoBtn,
  DemoChips,
  DemoInput,
  DemoSelect,
  DemoTabs,
  DemoTextarea,
  Field,
  Flash,
  useFlash,
} from './demoKit'

/** Demos L3 interativas — telas compostas com estado. */

function ScreenFrame({ title, actions, children }) {
  return (
    <div className="erp-screen-frame">
      <div className="erp-mock-head erp-mock-head--actions">
        <h3 className="erp-mock-h3 mb-0">{title}</h3>
        {actions}
      </div>
      {children}
    </div>
  )
}

const ROWS = [
  { cod: 'CT-2401', cliente: 'Ecossis Soluções', status: 'ativo', valor: 'R$ 12.000' },
  { cod: 'CT-2402', cliente: 'Projeto Oikos Lab', status: 'pendente', valor: 'R$ 8.500' },
  { cod: 'CT-2403', cliente: 'Operações SSA', status: 'ativo', valor: 'R$ 3.200' },
]

const CONTRACTS_OIKOS = [
  {
    cliente: 'COMPANHIA DE GÁS DO ESTADO',
    setor: 'Óleo e Gás',
    numero: '4500123489',
    valor: 'R$ 3.600.152,50',
    assinatura: '12/03/2024',
    vigencia: '11/03/2027',
  },
  {
    cliente: 'COPEL',
    setor: 'Energia',
    numero: '4500199021',
    valor: 'R$ 1.245.000,00',
    assinatura: '08/01/2025',
    vigencia: '07/01/2028',
  },
  {
    cliente: 'MOTIVA INFRAESTRUTURA',
    setor: 'Indústria',
    numero: '4500211567',
    valor: 'R$ 890.430,20',
    assinatura: '22/06/2025',
    vigencia: '21/06/2026',
  },
]

function OikosPageTitle({ title, clock }) {
  return (
    <div className="erp-oikos-page__titlebar">
      <h2>{title}</h2>
      {clock ? <p className="erp-oikos-page__clock">{clock}</p> : null}
    </div>
  )
}

const SCREEN_MOCKS = {
  screenListA: () => {
    const [tab, setTab] = useState('vigentes')
    const { msg, tone, flash } = useFlash()
    const rows = tab === 'vigentes' ? CONTRACTS_OIKOS : CONTRACTS_OIKOS.slice(0, 1)
    return (
      <div className="erp-oikos-page">
        <OikosPageTitle title="Contratos Cadastrados" />
        <div className="erp-oikos-tabs" role="tablist">
          <button
            type="button"
            role="tab"
            className={tab === 'vigentes' ? 'is-on' : undefined}
            aria-selected={tab === 'vigentes'}
            onClick={() => setTab('vigentes')}
          >
            Vigentes (30)
          </button>
          <button
            type="button"
            role="tab"
            className={tab === 'nao' ? 'is-on' : undefined}
            aria-selected={tab === 'nao'}
            onClick={() => setTab('nao')}
          >
            Não vigentes (176)
          </button>
        </div>
        <div className="erp-oikos-table-wrap">
          <table className="erp-oikos-table">
            <thead>
              <tr>
                <th />
                <th>Cliente</th>
                <th>Setor</th>
                <th>Número</th>
                <th>Valor</th>
                <th>Data de assinatura</th>
                <th>Vigência</th>
                <th>Link PDF</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.numero} onClick={() => flash(`Abrir ${r.cliente}`)}>
                  <td>▾</td>
                  <td>{r.cliente}</td>
                  <td>{r.setor}</td>
                  <td>{r.numero}</td>
                  <td>{r.valor}</td>
                  <td>{r.assinatura}</td>
                  <td>{r.vigencia}</td>
                  <td>
                    <button
                      type="button"
                      className="erp-oikos-pdf"
                      onClick={(e) => {
                        e.stopPropagation()
                        flash('Abrir PDF')
                      }}
                    >
                      PDF
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <Flash message={msg} tone={tone} />
      </div>
    )
  },
  screenListB: () => {
    const [chips, setChips] = useState(['Aberto', '2026'])
    const { msg, tone, flash } = useFlash()
    return (
      <ScreenFrame
        title="Contratos"
        actions={
          <DemoBtn variant="primary" onClick={() => flash('Novo')}>
            Novo
          </DemoBtn>
        }
      >
        <DemoChips
          values={chips}
          onRemove={(x) => setChips(chips.filter((c) => c !== x))}
          onAdd={() => {
            if (!chips.includes('SSA')) setChips([...chips, 'SSA'])
          }}
          addLabel="+ filtro"
        />
        <table className="erp-mock-table erp-demo-table">
          <thead>
            <tr>
              <th>Código</th>
              <th>Valor</th>
            </tr>
          </thead>
          <tbody>
            {ROWS.map((r) => (
              <tr key={r.cod} onClick={() => flash(r.cod)}>
                <td>{r.cod}</td>
                <td>{r.valor}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <Flash message={msg} tone={tone} />
      </ScreenFrame>
    )
  },
  screenListC: () => {
    const [empty, setEmpty] = useState(true)
    const { msg, tone, flash } = useFlash()
    return (
      <ScreenFrame
        title="Contratos"
        actions={
          <DemoBtn
            variant="primary"
            onClick={() => {
              setEmpty(false)
              flash('Criado')
            }}
          >
            Novo
          </DemoBtn>
        }
      >
        {empty ? (
          <Box className="erp-mock-empty">
            <strong>Nenhum contrato</strong>
            <span>Comece criando o primeiro.</span>
            <DemoBtn
              variant="primary"
              onClick={() => {
                setEmpty(false)
                flash('Criado')
              }}
            >
              Criar
            </DemoBtn>
          </Box>
        ) : (
          <table className="erp-mock-table">
            <tbody>
              <tr>
                <td>C-01</td>
                <td>Alpha</td>
              </tr>
            </tbody>
          </table>
        )}
        <Flash message={msg} tone={tone} />
      </ScreenFrame>
    )
  },

  screenEditA: () => {
    const [nome, setNome] = useState('')
    const [doc, setDoc] = useState('')
    const { msg, tone, flash } = useFlash()
    return (
      <ScreenFrame title="Novo fornecedor">
        <div className="erp-mock-acc is-open">1. Identificação ▾</div>
        <div className="erp-mock-acc-body">
          <Field label="Razão social">
            <DemoInput value={nome} onChange={setNome} />
          </Field>
          <Field label="CNPJ">
            <DemoInput value={doc} onChange={setDoc} />
          </Field>
        </div>
        <div className="erp-mock-acc">2. Endereço ▸</div>
        <div className="erp-mock-acc">3. Anexos ▸</div>
        <div className="erp-mock-head erp-mock-head--actions" style={{ marginTop: '0.5rem' }}>
          <DemoBtn variant="ghost" onClick={() => flash('Cancelado', 'warn')}>
            Cancelar
          </DemoBtn>
          <DemoBtn variant="primary" onClick={() => flash(`Salvo: ${nome || '(vazio)'}`)}>
            Salvar
          </DemoBtn>
        </div>
        <Flash message={msg} tone={tone} />
      </ScreenFrame>
    )
  },
  screenEditB: () => {
    const [f, setF] = useState({ nome: '', cnpj: '', email: '', tel: '' })
    const { msg, tone, flash } = useFlash()
    return (
      <ScreenFrame title="Editar fornecedor">
        <Box className="erp-mock-form-2">
          <Field label="Nome">
            <DemoInput value={f.nome} onChange={(nome) => setF({ ...f, nome })} />
          </Field>
          <Field label="CNPJ">
            <DemoInput value={f.cnpj} onChange={(cnpj) => setF({ ...f, cnpj })} />
          </Field>
          <Field label="E-mail">
            <DemoInput value={f.email} onChange={(email) => setF({ ...f, email })} />
          </Field>
          <Field label="Telefone">
            <DemoInput value={f.tel} onChange={(tel) => setF({ ...f, tel })} />
          </Field>
        </Box>
        <div className="erp-mock-head erp-mock-head--actions">
          <DemoBtn variant="outline" onClick={() => flash('Cancelado', 'warn')}>
            Cancelar
          </DemoBtn>
          <DemoBtn variant="primary" onClick={() => flash('Salvo ✓')}>
            Salvar
          </DemoBtn>
        </div>
        <Flash message={msg} tone={tone} />
      </ScreenFrame>
    )
  },
  screenEditC: () => {
    const [step, setStep] = useState(1)
    const [cep, setCep] = useState('')
    const { msg, tone, flash } = useFlash()
    return (
      <ScreenFrame title="Novo fornecedor">
        <div className="erp-mock-steps erp-mock-steps--num erp-demo-steps">
          {[1, 2, 3].map((n, idx) => (
            <React.Fragment key={n}>
              <button
                type="button"
                className={n < step ? 'is-done' : n === step ? 'is-now' : ''}
                onClick={() => setStep(n)}
              >
                {n}
              </button>
              {idx < 2 && <i />}
            </React.Fragment>
          ))}
        </div>
        <div className="erp-mock-step-labels">
          <span>Dados</span>
          <span>Endereço</span>
          <span>Anexos</span>
        </div>
        {step === 2 && (
          <Field label="CEP">
            <DemoInput value={cep} onChange={setCep} />
          </Field>
        )}
        {step !== 2 && <span className="small text-muted">Etapa {step}</span>}
        <div className="erp-mock-head erp-mock-head--actions">
          <DemoBtn variant="outline" disabled={step === 1} onClick={() => setStep(step - 1)}>
            Voltar
          </DemoBtn>
          <DemoBtn
            variant="primary"
            onClick={() => {
              if (step === 3) flash('Concluído ✓')
              else setStep(step + 1)
            }}
          >
            {step === 3 ? 'Salvar' : 'Próximo'}
          </DemoBtn>
        </div>
        <Flash message={msg} tone={tone} />
      </ScreenFrame>
    )
  },

  screenDetailA: () => {
    const [tab, setTab] = useState('geral')
    return (
      <ScreenFrame title="Projeto Alpha" actions={<span className="erp-mock-pill is-ok">Ativo</span>}>
        <span className="erp-mock-crumb">Início / Projetos / Alpha</span>
        <DemoTabs
          tabs={[
            { id: 'geral', label: 'Geral' },
            { id: 'equipe', label: 'Equipe' },
            { id: 'fin', label: 'Financeiro' },
            { id: 'anexos', label: 'Anexos' },
          ]}
          active={tab}
          onChange={setTab}
        >
          Conteúdo da aba <strong>{tab}</strong>
        </DemoTabs>
      </ScreenFrame>
    )
  },
  screenDetailB: () => {
    const [open, setOpen] = useState(true)
    const [nome, setNome] = useState('Alpha')
    const [tab, setTab] = useState('geral')
    const { msg, tone, flash } = useFlash()
    return (
      <div className="erp-screen-split">
        <ScreenFrame
          title="Projeto Alpha"
          actions={
            <DemoBtn variant="outline" onClick={() => setOpen(true)}>
              Editar
            </DemoBtn>
          }
        >
          <DemoTabs
            tabs={[
              { id: 'geral', label: 'Geral' },
              { id: 'equipe', label: 'Equipe' },
            ]}
            active={tab}
            onChange={setTab}
          >
            Aba {tab}
          </DemoTabs>
        </ScreenFrame>
        {open && (
          <div className="erp-mock-drawer">
            <div className="erp-mock-drawer__bar">
              Editar{' '}
              <button type="button" className="erp-demo-x" onClick={() => setOpen(false)}>
                ×
              </button>
            </div>
            <div className="erp-mock-drawer__body">
              <Field label="Nome">
                <DemoInput value={nome} onChange={setNome} />
              </Field>
              <DemoBtn
                variant="primary"
                onClick={() => {
                  flash(`Salvo: ${nome}`)
                  setOpen(false)
                }}
              >
                Salvar
              </DemoBtn>
            </div>
          </div>
        )}
        <Flash message={msg} tone={tone} />
      </div>
    )
  },
  screenDetailC: () => {
    const [tab, setTab] = useState('fin')
    return (
      <div className="erp-screen-split erp-screen-split--summary">
        <aside className="erp-screen-summary">
          <strong>Alpha</strong>
          <p className="erp-mock-dl">
            <span>Status</span>
            <strong>Ativo</strong>
          </p>
          <p className="erp-mock-dl">
            <span>EP</span>
            <strong>Salvador</strong>
          </p>
        </aside>
        <ScreenFrame title="Detalhe">
          <DemoTabs
            tabs={[
              { id: 'fin', label: 'Financeiro' },
              { id: 'anexos', label: 'Anexos' },
            ]}
            active={tab}
            onChange={setTab}
          >
            Painel: {tab}
          </DemoTabs>
        </ScreenFrame>
      </div>
    )
  },

  screenDashA: () => {
    const { msg, tone, flash } = useFlash()
    return (
      <div className="erp-oikos-page">
        <OikosPageTitle
          title="Dashboard"
          clock="sexta-feira, 11 de setembro de 2026, 16:26"
        />
        <div className="erp-oikos-kpis">
          <div className="erp-oikos-card">
            <span className="erp-oikos-card__label">Expediente atual</span>
            <span className="erp-oikos-card__value">02h30min</span>
            <span className="erp-oikos-card__foot">Entrada: hoje às 13:56</span>
          </div>
          <div className="erp-oikos-card">
            <span className="erp-oikos-card__label">Carga horária restante no mês</span>
            <div className="erp-oikos-card__loading">
              <span className="erp-mock-spinner erp-mock-spinner--sm" aria-hidden />
              Carregando…
            </div>
            <span className="erp-oikos-card__foot">% realizado até o momento</span>
          </div>
          <div className="erp-oikos-card">
            <span className="erp-oikos-card__label">Banco de horas</span>
            <span className="erp-oikos-card__value">-29h37min</span>
            <span className="erp-oikos-card__foot">-32h52min em relação ao mês anterior</span>
          </div>
        </div>
        <div className="erp-oikos-grid">
          <div className="erp-oikos-card">
            <div className="erp-oikos-card__head">
              <strong>Carga horária mensal</strong>
            </div>
            <div className="erp-oikos-chart-blank" aria-hidden />
          </div>
          <div>
            <div className="erp-oikos-card" style={{ marginBottom: '0.85rem' }}>
              <div className="erp-oikos-card__head">
                <strong>Meus Projetos</strong>
                <button type="button" className="erp-oikos-btn-green" onClick={() => flash('Exibir todos')}>
                  Exibir todos
                </button>
              </div>
            </div>
            <div className="erp-oikos-card">
              <div className="erp-oikos-card__head">
                <strong>Agenda</strong>
                <button type="button" className="erp-oikos-btn-green" onClick={() => flash('Ver tudo')}>
                  Ver tudo
                </button>
              </div>
              {[1, 2, 3].map((i) => (
                <div key={i} className="erp-oikos-agenda-item">
                  <time>9:00 AM - 11:00 AM</time>
                  <span>Reunião de P&amp;D · Microsoft Teams Meeting</span>
                </div>
              ))}
            </div>
          </div>
          <div className="erp-oikos-card" style={{ gridColumn: '1 / -1' }}>
            <div className="erp-oikos-card__head">
              <strong>Distribuição das atividades (%)</strong>
              <span className="small text-muted">09/2026</span>
            </div>
            <div className="erp-oikos-pie" aria-hidden />
          </div>
        </div>
        <Flash message={msg} tone={tone} />
      </div>
    )
  },
  screenDashB: () => {
    const [pct, setPct] = useState(76)
    return (
      <ScreenFrame title="Visão geral">
        <div className="erp-screen-kpis erp-screen-kpis--grid">
          <div className="erp-mock-kpi">
            <span className="erp-mock-kpi__value">{pct}%</span>
            <div className="erp-mock-meter">
              <span style={{ width: `${pct}%` }} />
            </div>
            <input
              type="range"
              min={0}
              max={100}
              value={pct}
              onChange={(e) => setPct(Number(e.target.value))}
              className="erp-demo-range"
            />
            <span className="erp-mock-kpi__label">Meta</span>
          </div>
          <div className="erp-mock-kpi">
            <span className="erp-mock-kpi__value">↑ 12%</span>
            <span className="erp-mock-kpi__label">Vs mês</span>
          </div>
          <div className="erp-mock-kpi">
            <span className="erp-mock-kpi__value">9</span>
            <span className="erp-mock-kpi__label">Aprovações</span>
          </div>
          <div className="erp-mock-kpi">
            <span className="erp-mock-kpi__value">3</span>
            <span className="erp-mock-kpi__label">Alertas</span>
          </div>
        </div>
      </ScreenFrame>
    )
  },
  screenDashC: () => {
    const { msg, tone, flash } = useFlash()
    return (
      <ScreenFrame
        title="Receita"
        actions={
          <DemoBtn variant="outline" onClick={() => flash('Exportando…')}>
            Exportar
          </DemoBtn>
        }
      >
        <svg className="erp-mock-linechart" viewBox="0 0 200 80" aria-hidden>
          <polyline
            fill="none"
            stroke="#339933"
            strokeWidth="2"
            points="0,60 40,45 80,50 120,25 160,35 200,15"
          />
        </svg>
        <div className="erp-mock-row" style={{ marginTop: '0.5rem' }}>
          <DemoBtn variant="primary" onClick={() => flash('Novo pedido')}>
            Novo pedido
          </DemoBtn>
          <DemoBtn variant="outline" onClick={() => flash('Abrir fila')}>
            Ver fila
          </DemoBtn>
        </div>
        <Flash message={msg} tone={tone} />
      </ScreenFrame>
    )
  },

  screenApprovalA: () => {
    const fila = [
      { id: '881', titulo: 'Compra', valor: 'R$ 4.200' },
      { id: '882', titulo: 'Viagem', valor: 'R$ 980' },
    ]
    const [sel, setSel] = useState('881')
    const [motivo, setMotivo] = useState('')
    const { msg, tone, flash } = useFlash()
    const item = fila.find((f) => f.id === sel)
    return (
      <div className="erp-screen-split">
        <Box>
          {fila.map((f) => (
            <button
              key={f.id}
              type="button"
              className={`erp-mock-queue-item erp-demo-queue${sel === f.id ? ' is-on' : ''}`}
              onClick={() => setSel(f.id)}
            >
              <strong>#{f.id}</strong> {f.titulo} · {f.valor}
              <span className="erp-mock-pill is-warn">Pendente</span>
            </button>
          ))}
        </Box>
        <Box className="erp-mock-apcard">
          <strong>Pedido #{item.id}</strong>
          <p>
            {item.titulo} — {item.valor}
          </p>
          <Field label="Motivo">
            <DemoTextarea value={motivo} onChange={setMotivo} />
          </Field>
          <div>
            <DemoBtn variant="danger-outline" onClick={() => flash('Rejeitado', 'err')}>
              Rejeitar
            </DemoBtn>
            <DemoBtn variant="primary" onClick={() => flash('Aprovado ✓')}>
              Aprovar
            </DemoBtn>
          </div>
          <Flash message={msg} tone={tone} />
        </Box>
      </div>
    )
  },
  screenApprovalB: () => {
    const { msg, tone, flash } = useFlash()
    return (
      <ScreenFrame title="Fila de aprovação">
        <table className="erp-mock-table">
          <thead>
            <tr>
              <th>Pedido</th>
              <th>Valor</th>
              <th />
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>#881</td>
              <td>R$ 4.200</td>
              <td>
                <DemoBtn variant="primary" onClick={() => flash('Aprovado #881')}>
                  Aprovar
                </DemoBtn>
              </td>
            </tr>
            <tr>
              <td>#882</td>
              <td>R$ 980</td>
              <td>
                <DemoBtn variant="primary" onClick={() => flash('Aprovado #882')}>
                  Aprovar
                </DemoBtn>
              </td>
            </tr>
          </tbody>
        </table>
        <Flash message={msg} tone={tone} />
      </ScreenFrame>
    )
  },
  screenApprovalC: () => {
    const [items, setItems] = useState([
      { id: '881', t: 'Compra', v: 'R$ 4.200' },
      { id: '882', t: 'Viagem', v: 'R$ 980' },
    ])
    const { msg, tone, flash } = useFlash()
    const decide = (id, ok) => {
      setItems(items.filter((x) => x.id !== id))
      flash(ok ? `Aprovado #${id}` : `Rejeitado #${id}`, ok ? 'ok' : 'err')
    }
    return (
      <Box>
        {!items.length && <span className="text-muted small">Fila vazia</span>}
        {items.map((it) => (
          <div key={it.id} className="erp-mock-apcard" style={{ marginBottom: '0.5rem' }}>
            <strong>
              #{it.id} · {it.t}
            </strong>
            <p>{it.v}</p>
            <div className="erp-mock-apcard__full">
              <DemoBtn variant="danger" onClick={() => decide(it.id, false)}>
                Rejeitar
              </DemoBtn>
              <DemoBtn variant="primary" onClick={() => decide(it.id, true)}>
                Aprovar
              </DemoBtn>
            </div>
          </div>
        ))}
        <Flash message={msg} tone={tone} />
      </Box>
    )
  },
}

export default function ScreenMock({ mockId }) {
  const Comp = SCREEN_MOCKS[mockId]
  if (!Comp) {
    return <div className="erp-mock-box text-muted small">Screen mock: {mockId}</div>
  }
  return <Comp />
}
